import { useState } from "react";
import "./ImageModal.css";
interface ImageModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}

const ImageModal = ({ open, onClose, onSubmit }: ImageModalProps) => {
  const [src, setSrc] = useState("");
  const [alt, setAlt] = useState("");
  const [caption, setCaption] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");

  if (!open) return null;

  return (
    <div className="link-modal-backdrop">
      <div className="image-modal">
        <h3>Chèn hình ảnh</h3>

        {/* Preview */}
        <label className="image-preview">
          {src ? (
            <img src={src} alt="preview" />
          ) : (
            <div className="placeholder">
              <span>Click để chọn ảnh</span>
            </div>
          )}

          <input
            type="file"
            accept="image/*"
            hidden
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (!file) return;

              const reader = new FileReader();
              reader.onload = () => {
                setSrc(reader.result as string);
              };
              reader.readAsDataURL(file);
            }}
          />
        </label>

        <div className="divInput">
          <input
            placeholder="Alt (SEO)"
            value={alt}
            onChange={(e) => setAlt(e.target.value)}
          />
          <input
            placeholder="Chú thích (caption)"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
          />
          <input
            placeholder="Width (vd: 300 hoặc 500)"
            value={width}
            onChange={(e) => setWidth(e.target.value)}
          />
          <input
            placeholder="Height (vd: 200 hoặc 300)"
            value={height}
            onChange={(e) => setHeight(e.target.value)}
          />
        </div>

        <div className="actions">
          <button onClick={onClose}>Hủy</button>
          <button
            className="primary"
            onClick={() => {
              if (!src) return;
              onSubmit({ src, alt, caption, width, height });
            }}>
            Chèn ảnh
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
